import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {TriStateCheckbox} from 'primereact/tristatecheckbox';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import moment from "moment/moment";
import {Calendar} from "primereact/calendar";

const CheckinListComponent = (props) => {

  const {t} = props;
  const [checkins, setCheckins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [checkinRange, setCheckinRange] = useState(null);
  const [checkoutRange, setCheckoutRange] = useState(null);
  const [retroactivelyTri, setRetroactivelyTri] = useState(null);
  const [checkOutForcedTri, setCheckOutForcedTri] = useState(null);
  const [identifierTypes, setIdentifierTypes] = useState([]);
  const dt = useRef(null);
  const [checkintypeDict, setCheckinTypeDict] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;

  const clearFieldSearch = (sp, field) => {
    sp.delete(`search[${field}]`);
    sp.delete(`search[${field}][operator]`);
    sp.delete(`search[${field}][operator][]`);
    sp.delete(`search[${field}][value]`);
    sp.delete(`search[${field}][value][]`);
  };

  const addRangeSearch = (sp, field, range) => {
    const [from, to] = range || [];
    if (!from) return;
    const fromStr = moment(from).format('YYYY-MM-DD 00:00:00');
    if (!to) {
      sp.set(`search[${field}][operator]`, '>=');
      sp.set(`search[${field}][value]`, fromStr);
      return;
    }
    const toStr = moment(to).format('YYYY-MM-DD 23:59:59');
    sp.set(`search[${field}][operator]`, 'between');
    sp.set(`search[${field}][value]`, `${fromStr},${toStr}`);
  };

  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const baseQuery = window.App.transformQueryParams(lazyParams) || '';
      const sp = new URLSearchParams(baseQuery.startsWith('?') ? baseQuery.slice(1) : baseQuery);
      clearFieldSearch(sp, 'check_in_at');
      clearFieldSearch(sp, 'check_out_at');
      addRangeSearch(sp, 'check_in_at', checkinRange);
      addRangeSearch(sp, 'check_out_at', checkoutRange);
      addBooleanSearch(sp, 'retroactively', retroactivelyTri);
      addBooleanSearch(sp, 'check_out_forced', checkOutForcedTri);
      const query = sp.toString() ? `?${sp.toString()}` : '';
      // console.log('CHECKIN QUERY =>', '/api/v2/checkin' + query);
      apiCall('get', '/api/v2/checkin' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCheckins(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      apiCall('get', '/api/v2/dictionary/identifier-type')
        .then(response => {
          setIdentifierTypes(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        });
      apiCall('get', '/api/v2/dictionary/checkin-type')
        .then(response => {
          setCheckinTypeDict(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        });
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    if (_lazyParams.filters) {
      delete _lazyParams.filters['check_in_at'];
      delete _lazyParams.filters['check_out_at'];
    }
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];
      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const translateIdentifierType = (key) => {
    const found = identifierTypes.find((x) => x.key === key);
    return found ? found.value : key;
  };

  const translateCheckinType = (key) => {
    const found = checkintypeDict.find((x) => x.key === key);
    return found ? found.value : key;
  }

  const addBooleanSearch = (sp, field, val) => {
    clearFieldSearch(sp, field);
    if (val === null || val === undefined) return;
    sp.set(`search[${field}][operator]`, '=');
    sp.set(`search[${field}][value]`, val ? 'true' : 'false');
  };

  const booleanFilter = (field) => {
    const value = field === 'retroactively' ? retroactivelyTri : checkOutForcedTri;
    return (
      <TriStateCheckbox
        value={value}
        onChange={(e) => {
          if (field === 'retroactively') setRetroactivelyTri(e.value);
          if (field === 'check_out_forced') setCheckOutForcedTri(e.value);
          setLazyParams(prev => ({ ...prev, first: 0, page: 0 }));
        }}
      />
    );
  };

  const onDateRangeChange = (field, range) => {
    if (field === 'check_in_at') setCheckinRange(range);
    if (field === 'check_out_at') setCheckoutRange(range);
    setLazyParams(prev => ({
      ...prev,
      first: 0,
      page: 0
    }));
  };

  const clearDateRange = (field) => {
    if (field === 'check_in_at') setCheckinRange(null);
    if (field === 'check_out_at') setCheckoutRange(null);
    setLazyParams(prev => ({
      ...prev,
      first: 0,
      page: 0
    }));
  };

  const dateRangeFilterTemplate = (field, placeholder=t('dateRangePlaceholder')) => {
    const value = field === 'check_in_at' ? checkinRange : checkoutRange;
    return (
      <span style={{position: 'relative', display: 'block', width: '100%'}}>
        <Calendar
          value={value}
          selectionMode="range"
          readOnlyInput
          showIcon
          dateFormat="yy-mm-dd"
          appendTo={document.body}
          placeholder={placeholder}
          onChange={(e) => onDateRangeChange(field, e.value)}
          className="w-100"
        />
        {value && value[0] && (
          <button
            type="button"
            onClick={() => clearDateRange(field)}
            className="p-link"
            style={{
              position: 'absolute',
              right: '-1.75rem',
              top: '50%',
              transform: 'translateY(-50%)',
              padding: 0,
              lineHeight: 1,
              zIndex: 5
            }}
          >
            <i className="pi pi-times" />
          </button>
        )}
      </span>
    );
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCheckinList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={checkins} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="type" header={t('columnIdentificationMethod')} bodyClassName="col-body-font-bold" filter filterMatchMode="equals" sortable body={(rowData) => translateCheckinType(rowData.type)} 
        filterElement={() => {
          return (
            <>
              <Dropdown
                value={lazyParams.filters && lazyParams.filters['type'] ? lazyParams.filters['type'].value : null}
                options={checkintypeDict.map(x => ({label: x.value, value: x.key}))}
                showClear
                appendTo={document.body}
                onChange={(e) => {
                  const value = e.value;
                  setLazyParams(prev => {
                    const next = {
                      ...prev,
                      first: 0,
                      page: 0,
                      filters: {
                        ...(prev.filters || {})
                      }
                    };
                    if (value === null || value === undefined || value === '') {
                      delete next.filters['type'];
                    } else {
                      next.filters['type'] = {
                        value,
                        matchMode: 'equals'
                      };
                    }
                    return next;
                  });
                }}
              />
            </>
          )
        }}></Column>
          <Column field="retroactively" header={t('columnArrivalAddedRetroactively')} filter filterMatchMode='equals' filterElement={booleanFilter('retroactively')} sortable className={""} body={(rowData) => {
              return (
                  <>
                      {rowData.retroactively === true ? (
                          <i className={"pi pi-check text-danger"}></i>
                      ) : (
                          <i className={"pi pi-times text-success"}></i>
                      )}
                  </>
              )
          }}
          ></Column>
          <Column field="check_out_forced" header={t('columnDepartureMissing')} filter filterMatchMode="equals" filterElement={booleanFilter('check_out_forced')} sortable className={""} body={(rowData) => {
              return (
                  <>
                      {rowData.check_out_forced === true ? (
                          <i className={"pi pi-check text-danger"}></i>
                      ) : (
                          <i className={"pi pi-times text-success"}></i>
                      )}
                  </>
              )
          }}
          ></Column>
        <Column field="employee.name" header={t('columnEmployee')} bodyClassName="col-body-font-bold" filter filterField={"employee_name"}></Column>
        <Column field="place_identifier.name" header={t('columnIdentifiedLocation')} filterField={"place_identifier"} filter></Column>
        <Column field="custom_place" header={t('columnCustomLocation')} filter sortable></Column>
        <Column field="check_in_at" header={t('columnArrival')} className={"p-text-nowrap"} sortable filter showFilterMenu={false}
                filterElement={dateRangeFilterTemplate('check_in_at')}></Column>
        <Column field="check_out_at" header={t('columnDeparture')} className={"p-text-nowrap"} sortable filter showFilterMenu={false}
                filterElement={dateRangeFilterTemplate('check_out_at')}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(CheckinListComponent);
